const LIGHT = { sage: "#A9BC98", stem: "#8FA37E", leaf: "#B7C7A6", ink: "#0C3B2E" };
const DARK = { sage: "#CBD9BA", stem: "#9DB08D", leaf: "#D9E4CC", ink: "#FFFFFF" };

const VARIANTS = {
  tangle: (c) => (
    <>
      <g fill="none" strokeLinecap="round">
        <path d="M70 150 C 90 60, 180 220, 150 120 S 260 70, 230 160 S 130 200, 190 110 S 320 140, 270 200" stroke={c.sage} strokeWidth="2" opacity="0.85" />
        <path d="M90 195 C 140 95, 220 240, 260 135 S 350 195, 295 235" stroke={c.sage} strokeWidth="2" opacity="0.6" />
        <path d="M110 105 C 175 170, 85 235, 200 195 S 305 115, 340 185" stroke={c.sage} strokeWidth="2" opacity="0.45" />
        <path d="M60 335 C 150 325, 270 350, 362 332" stroke={c.ink} strokeWidth="2.5" />
      </g>
      <circle cx="362" cy="332" r="4.5" fill={c.ink} />
      <path d="M362 332 q 16 -22 34 -17 q -8 22 -34 17" fill={c.sage} />
      <path d="M345 55 C 355 95, 352 135, 344 172" stroke={c.stem} strokeWidth="2" fill="none" strokeLinecap="round" />
      <g fill={c.leaf}>
        <ellipse cx="334" cy="76" rx="15" ry="7.5" transform="rotate(-38 334 76)" />
        <ellipse cx="357" cy="98" rx="15" ry="7.5" transform="rotate(28 357 98)" />
        <ellipse cx="331" cy="122" rx="14" ry="7" transform="rotate(-30 331 122)" />
        <ellipse cx="352" cy="146" rx="13" ry="6.5" transform="rotate(22 352 146)" />
      </g>
    </>
  ),
  knot: (c) => (
    <>
      <g fill="none" strokeLinecap="round">
        <path d="M45 235 C 105 150, 150 305, 200 232 C 228 192, 272 190, 288 228 C 301 260, 268 288, 246 262 C 230 242, 248 208, 296 216 C 330 222, 356 226, 380 218" stroke={c.ink} strokeWidth="2.5" />
        <path d="M45 275 C 120 258, 260 288, 380 262" stroke={c.sage} strokeWidth="2" opacity="0.45" />
      </g>
      <circle cx="380" cy="218" r="4.5" fill={c.ink} />
      <path d="M380 218 q 15 -20 32 -15 q -7 20 -32 15" fill={c.sage} />
    </>
  ),
  sprout: (c) => (
    <>
      <g fill="none" strokeLinecap="round">
        <path d="M105 335 Q 210 298 315 335" stroke={c.ink} strokeWidth="2.5" />
        <path d="M210 325 C 203 278, 217 246, 209 198" stroke={c.stem} strokeWidth="2.5" />
      </g>
      <ellipse cx="188" cy="252" rx="17" ry="8.5" transform="rotate(-32 188 252)" fill={c.leaf} />
      <ellipse cx="234" cy="232" rx="17" ry="8.5" transform="rotate(30 234 232)" fill={c.leaf} />
      <ellipse cx="193" cy="205" rx="14" ry="7" transform="rotate(-38 193 205)" fill={c.sage} />
      <ellipse cx="226" cy="188" rx="14" ry="7" transform="rotate(25 226 188)" fill={c.sage} />
      <circle cx="209" cy="192" r="4" fill={c.ink} />
    </>
  ),
  branch: (c) => (
    <>
      <path d="M110 360 C 160 285, 225 205, 305 105" fill="none" stroke={c.stem} strokeWidth="2.5" strokeLinecap="round" />
      <g fill={c.leaf}>
        <ellipse cx="138" cy="322" rx="16" ry="8" transform="rotate(-40 138 322)" />
        <ellipse cx="176" cy="300" rx="16" ry="8" transform="rotate(25 176 300)" />
        <ellipse cx="196" cy="262" rx="15" ry="7.5" transform="rotate(-35 196 262)" />
        <ellipse cx="232" cy="238" rx="15" ry="7.5" transform="rotate(28 232 238)" />
        <ellipse cx="250" cy="198" rx="14" ry="7" transform="rotate(-30 250 198)" />
        <ellipse cx="282" cy="172" rx="14" ry="7" transform="rotate(30 282 172)" />
        <ellipse cx="294" cy="132" rx="12" ry="6" transform="rotate(-18 294 132)" />
      </g>
      <circle cx="305" cy="105" r="4" fill={c.sage} />
    </>
  ),
  horizon: (c) => (
    <>
      <circle cx="210" cy="168" r="30" fill={c.sage} opacity="0.9" />
      <g fill="none" strokeLinecap="round">
        <path d="M40 305 C 125 285, 295 322, 395 292" stroke={c.ink} strokeWidth="2.5" />
        <path d="M70 345 C 155 328, 275 355, 365 335" stroke={c.sage} strokeWidth="2" opacity="0.6" />
        <path d="M120 302 q 5 -16 0 -26" stroke={c.stem} strokeWidth="2" />
        <path d="M330 296 q -5 -15 1 -25" stroke={c.stem} strokeWidth="2" />
      </g>
      <ellipse cx="112" cy="276" rx="10" ry="5" transform="rotate(-30 112 276)" fill={c.leaf} />
      <ellipse cx="338" cy="271" rx="10" ry="5" transform="rotate(28 338 271)" fill={c.leaf} />
    </>
  ),
  seed: (c) => (
    <>
      <circle cx="210" cy="230" r="9" fill={c.ink} />
      <g fill="none" stroke={c.sage} strokeWidth="2">
        <circle cx="210" cy="230" r="48" opacity="0.85" />
        <circle cx="210" cy="230" r="88" opacity="0.55" />
        <circle cx="210" cy="230" r="128" opacity="0.3" />
      </g>
      <path d="M210 221 C 206 200, 214 188, 210 172" fill="none" stroke={c.stem} strokeWidth="2" strokeLinecap="round" />
      <ellipse cx="196" cy="188" rx="13" ry="6.5" transform="rotate(-35 196 188)" fill={c.leaf} />
      <ellipse cx="224" cy="180" rx="13" ry="6.5" transform="rotate(28 224 180)" fill={c.leaf} />
    </>
  ),
};

const LABELS = {
  tangle: "A tangled mind being gently untangled into a single calm line",
  knot: "A line forming a gentle knot, then loosening again",
  sprout: "A small sprout growing from the ground",
  branch: "A eucalyptus branch with soft leaves",
  horizon: "A calm horizon under a rising sun",
  seed: "A seed with soft ripples growing outward",
};

export default function BotanicalArt({ variant = "tangle", caption, dark = false, className = "" }) {
  const c = dark ? DARK : LIGHT;
  const draw = VARIANTS[variant] || VARIANTS.tangle;
  return (
    <div
      className={`rounded-[2rem] border p-8 md:p-10 ${dark ? "border-white/15 bg-white/5" : "border-border bg-secondary"} ${className}`}
      data-testid={`botanical-${variant}`}
    >
      <svg viewBox="0 0 420 440" className="mx-auto w-full max-w-sm" role="img" aria-label={LABELS[variant]}>
        {draw(c)}
      </svg>
      {caption && (
        <p className={`mt-4 text-center font-serif text-lg italic ${dark ? "text-primary-foreground/70" : "text-foreground/70"}`}>
          {caption}
        </p>
      )}
    </div>
  );
}
